var exports = {
  "Tc": "ChannelUserTag.module__tag___OFBEUn",
  "Dm": "ChannelUserTag.module__tagSm___OFBEUn",
  "ST": "ChannelUserTag.module__tagLg___OFBEUn",
  "Qq": "ChannelUserTag.module__text___OFBEUn",
  "WV": "ChannelUserTag.module__textSm___OFBEUn",
  "j": "ChannelUserTag.module__textLg___OFBEUn",
};

module.exports = exports;
